import * as React from 'react';
import classNames from 'classnames';
import { CSSProperties } from 'react';
import { isNotNullOrUndefined, isNullOrUndefined, stringIsEmpty } from 'Util/TypeGuards';

export interface TagProps {
	text?: string | null;
	customStyles?: CSSProperties;
	tagClassName?: string;
}

export function Tag({ text, customStyles, tagClassName }: TagProps) {
	if (stringIsEmpty(text)) {
		return null;
	}
	let className = isNotNullOrUndefined(tagClassName) ? tagClassName : 'tag--primary';
	if (isNotNullOrUndefined(customStyles?.background) || isNotNullOrUndefined(customStyles?.backgroundColor)) {
		className = '';
	}

	return (
		<span className={classNames('tag', className)} style={customStyles}>
			{text}
		</span>
	);
}
